import Component from '@cell/cell-core/component/component';

import './size-banner.scss';

class SizeBanner extends Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick() {
    this.classList.toggle('SizeBanner--Active');
  }
}

customElements.define('size-banner', SizeBanner);
